import { useRecoilState } from 'recoil';
import Select from 'src/common/components/select';
import { getSelectOptionsFromViewEnum } from 'src/common/helpers';
import { PriceChangeEnum, PriceChangeViewEnum } from 'src/constants/enums/priceChange';
import { IDropdownOption } from 'src/constants/interfaces';
import mainStore from 'src/stores/main';

import './style.scss';

const selectOptions = getSelectOptionsFromViewEnum(PriceChangeViewEnum);

const PriceChangeTypeSelect = () => {
    const [mainState, setMainState] = useRecoilState(mainStore);

    const changePriceType = ({ value }: IDropdownOption<string, PriceChangeEnum>) => {
        setMainState({ ...mainState, priceChangeType: value });
    };

    return <Select
        showSelected={false}
        showArrow={false}
        value={mainState.priceChangeType}
        className="B-betslip-price-change-select"
        placeholder={<span className="global-icon icon-Settings1" />}
        options={selectOptions}
        onChange={changePriceType}
    />;
};

export default PriceChangeTypeSelect;